import ReactGA from 'react-ga';

const googleAnalyticsAction={};
//const key = "G-LEBES77JEH"
googleAnalyticsAction.initGoogleAnalytics = async(key) => {
    ReactGA.initialize('G-LEBES77JEH');
    ReactGA.pageview(window.location.pathname + window.location.search);
};
export{googleAnalyticsAction};
